import React, { useState, useEffect, useCallback } from "react"
import { PriceTagIcon, ArrowDownIcon } from "../../common/Icons"
import "./ProductImageGallery.css"

export default function({ images }) {
  const [selectedImage, setSelectedImage] = useState(null)
  const [imageList, setImageList] = useState([])
  const [startIndex, setStartIndex] = useState(0)

  const selectImage = useCallback(
    function(index) {
      if (images && images.length > 0) setSelectedImage(images[index])
    },
    [images]
  )

  const initialImageList = useCallback(
    function() {
      if (images && images.length > 0) {
        setImageList(images.slice(0, 3))
        setStartIndex(0)
      }
    },
    [images]
  )

  function handlePrevClick() {
    if (startIndex - 1 >= 0 && images.length > 3) {
      setStartIndex(startIndex - 1)
    }
  }

  function handleNextClick() {
    if (startIndex + 1 <= 2 && images.length > 3) {
      setStartIndex(startIndex + 1)
    }
  }

  useEffect(
    () => {
      setImageList(images.slice(startIndex, startIndex + 3))
    },
    [startIndex, images]
  )

  useEffect(
    () => {
      selectImage(0)
      initialImageList()
    },
    [initialImageList, selectImage]
  )

  function handleImageButtonClick(e) {
    const index = e.target.value
    selectImage(index)
  }

  return (
    <div className="ProductImageGallery">
      {(images &&
        images.length > 0 && (
          <div className="gallery">
            <div className="gallery-buttons for-desktop">
              {images.map((e, i) => (
                <button
                  type="button"
                  key={i}
                  onClick={handleImageButtonClick}
                  value={i}
                  className={i === selectedImage ? "selected" : null}
                >
                  <img src={e} alt={`product ${i}`} />
                </button>
              ))}
            </div>
            <div className="scrollable-gallery-buttons for-mobile">
              <button
                type="button"
                onClick={handlePrevClick}
                className="prev"
                disabled={startIndex - 1 < 0 || images.length < 3}
              >
                <ArrowDownIcon />
              </button>
              <div className="gallery-buttons">
                {imageList.map((e, i) => (
                  <button
                    type="button"
                    key={i}
                    onClick={handleImageButtonClick}
                    value={i}
                    className={i === selectedImage ? "selected" : null}
                  >
                    <img src={e} alt={`product ${i}`} />
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={handleNextClick}
                className="next"
                disabled={startIndex + 1 > 2 || images.length < 3}
              >
                <ArrowDownIcon />
              </button>
            </div>

            {selectedImage && (
              <div className="gallery-selected">
                <img src={selectedImage} alt={selectedImage} />
              </div>
            )}
          </div>
        )) || (
        <div className="no-image">
          <PriceTagIcon />
        </div>
      )}
    </div>
  )
}
